import React from 'react';
import CustomMenu from './CustomMenu';
import { isMobile } from 'react-device-detect';
import InstallationPromo from '../InstallationPromo';
import { useLocation } from 'react-router-dom';
import { lazy, Suspense } from 'react';
const AnchorTopAds = lazy(() => import("../../Components/Ads"));
function Header({ isEnglish }) {
  const location = useLocation();
  // Check if current page is the tally counter
  const hideAnchorAds =
    location.pathname.toLowerCase().includes('tally') ||
    location.pathname.toLowerCase().includes('zakat') ||
    location.pathname.toLowerCase().includes('athkar');
  return (
    <div>
      {isMobile && !hideAnchorAds ? (
        <>
          <Suspense fallback={<div style={{ height: '100px', backgroundColor: 'transparent' }}></div>}>
            <AnchorTopAds />
          </Suspense>
          <div style={{ height: '100px', backgroundColor: 'transparent' }}></div>
        </>
      ) : null}
      <div >
        <CustomMenu />
      </div>
      {isMobile &&
        <>
          <InstallationPromo />
        </>
      }
      <br />
    </div>
  );
}
export default Header;